// 饼状 圆环
<template>
  <div v-if="seriesData.length" ref="chart" class="chart printItem"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name:'PieChart',
  components: {},
  props: {
    chartType: {
      type: String,
      default: () => '',
    },
    taskItemData: {
      type: Object,
      default: () => {},
    },
    exportChartList: {
      type: Object,
      default: () => {},
    },
    color: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      seriesData: [],
    };
  },
  watch: {
    taskItemData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.seriesData = Array.isArray(this.taskItemData.surveyItems)
          ? this.taskItemData.surveyItems.map(({ text, staffNum,rate }) => ({
              name: text,
              value: staffNum,
              rate: rate
            }))
          : [];
        this.$nextTick(() => {
         if (this.seriesData.length) this.initChart();
        });
      },
    },
  },
  computed: {
    showlegend() {
      return this.seriesData.length <= 50 ? true : false
    }
  },
  created() {},
  mounted() {
    // this.initChart()
  },
  methods: {
    getSeriesData(taskItemData) {
      let { surveyItems } = taskItemData;
      return surveyItems.map(({ text, staffNum }) => ({
        name: text,
        value: staffNum,
      }));
    },
    initChart() {
      if (this.chartType === '0') {
        this.initPieChart(this.taskItemData);
      } else if (this.chartType === '1') {
        this.initRingChart(this.taskItemData);
      }
    },
    initRingChart(taskItemData) {
      // !环形图
      let chartDom = this.$refs.chart;
      let myChart = echarts.init(chartDom);
      let option;
      option = {
        color: this.color,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          show: false,
          top: 'bottom',
          formatter: (name) => {
            return name.length > 5 ? `${name.slice(0, 5)}...` : name;
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true, // 标签是否重叠
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: this.showlegend,
              formatter(param) {
                return param.name.length > 6
                  ? `${param.name.slice(0, 5)}...(${param.data.rate}%)`
                  : `${param.name}(${param.data.rate}%)`;
              },
            },
            labelLine: {
              show: this.showlegend,
            },
            data: this.seriesData,
          },
        ],
      };

      option && myChart.setOption(option);
      this.exportChartList[this.chartType] = myChart;
    },
    initPieChart(taskItemData) {
      // !饼图
      let chartDom = this.$refs.chart;
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: this.color,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          show: false,
          top: 'bottom',
          formatter: (name) => {
            return name.length > 6 ? `${name.slice(0, 5)}...` : name;
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            avoidLabelOverlap: true, // 标签是否重叠
            data: this.seriesData,
            labelLine: {
              show: this.showlegend,
            },
            label: {
              show: this.showlegend,
              formatter(param) {
                return param.name.length > 6
                  ? `${param.name.slice(0, 5)}...(${param.data.rate}%)`
                  : `${param.name}(${param.data.rate}%)`;
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
      this.exportChartList[this.chartType] = myChart;
    },
  },
};
</script>

<style lang="less" scoped>
.chart {
  width: 625px;
  height: 400px;
  margin: 0 auto;
}
</style>
